import { MdToggleOff, MdToggleOn } from "react-icons/md";
import Card from "../../../components/Card";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function SystemSettingsCard({ settings, savingKey, handleToggleSetting }) {
  if (!settings) return null;
  return (
    <Card className="mb-6">
      <h2 className="text-xl font-semibold mb-4 text-text">System Settings</h2>
      <div className="space-y-4">
        <div className="flex items-center justify-between p-4 border border-border rounded-lg">
          <div>
            <p className="font-medium text-text">Enforce Tutor Availability</p>
            <p className="text-sm text-text opacity-70">When enabled, students can only request tutors for time slots when the tutor is available</p>
          </div>
          <button
            onClick={() => handleToggleSetting("enforceAvailability", !settings.enforceAvailability)}
            disabled={savingKey === "enforceAvailability"}
            className="flex items-center justify-center text-4xl text-secondary hover:opacity-80 transition-opacity disabled:opacity-50"
          >
            {settings.enforceAvailability ? <MdToggleOn /> : <MdToggleOff />}
            {savingKey === "enforceAvailability" && <LoadingSpinner size="sm" className="ml-2" />}
          </button>
        </div>
        <div className="flex items-center justify-between p-4 border border-border rounded-lg">
          <div>
            <p className="font-medium text-text">Hide Scheduled Sessions</p>
            <p className="text-sm text-text opacity-70">When enabled, sessions with 'Scheduled' status will be hidden from the admin sessions list</p>
          </div>
          <button
            onClick={() => handleToggleSetting("hideScheduledSessions", !settings.hideScheduledSessions)}
            disabled={savingKey === "hideScheduledSessions"}
            className="flex items-center justify-center text-4xl text-secondary hover:opacity-80 transition-opacity disabled:opacity-50"
          >
            {settings.hideScheduledSessions ? <MdToggleOn /> : <MdToggleOff />}
            {savingKey === "hideScheduledSessions" && <LoadingSpinner size="sm" className="ml-2" />}
          </button>
        </div>
        <div className="flex items-center justify-between p-4 border border-border rounded-lg">
          <div>
            <p className="font-medium text-text">Disable Tutor Signups</p>
            <p className="text-sm text-text opacity-70">When enabled, tutors cannot self-register via the public signup page. Admins can still create tutors.</p>
          </div>
          <button
            onClick={() => handleToggleSetting("disableTutorSignup", !settings.disableTutorSignup)}
            disabled={savingKey === "disableTutorSignup"}
            className="flex items-center justify-center text-4xl text-secondary hover:opacity-80 transition-opacity disabled:opacity-50"
          >
            {settings.disableTutorSignup ? <MdToggleOn /> : <MdToggleOff />}
            {savingKey === "disableTutorSignup" && <LoadingSpinner size="sm" className="ml-2" />}
          </button>
        </div>
      </div>
    </Card>
  );
}
